import { InMemoryCache } from "@apollo/client";

export const cache: InMemoryCache = new InMemoryCache();
export const cachev2: InMemoryCache = new InMemoryCache();
